import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss']
})
export class NewPasswordComponent implements OnInit {

  @ViewChild('newPassModal') newPassModal: ElementRef;

  newPassForm: FormGroup;
  missingFieldMsg = false;
  errorMsg = false;

  @Input() userData: any
  showSuccesfullMsg: boolean;
  password: any;
  validPass = false;

  constructor(private formBuilder: FormBuilder, private authService: AuthenticationService) { }

  ngOnInit(): void {
    this.newPassForm = this.formBuilder.group({
      UserName: ["", Validators.required],
      NewPwd: ["", Validators.required],
      Session: ["", Validators.required],
    });
  }

  ngOnChanges() {   
    console.log(this.userData);
    if(this.userData){
      this.newPassForm.patchValue({
        UserName: this.userData.ChallengeParameters.USER_ID_FOR_SRP,
        Session: this.userData.Session
      });
      this.newPassModal.nativeElement.click();
      
    }
    
  }

  checkPassword(){
    this.password = this.newPassForm.controls['NewPwd'].value;
  }

  checkPass(data:any){  
    console.log(data);
    this.validPass = data;
  }

  setNewPass(){
    this.missingFieldMsg = false;
    if (this.newPassForm.invalid) {
      this.missingFieldMsg = true;
      return;
    }
    let formObj = this.newPassForm.getRawValue();

    this.authService.setNewPassword(formObj).then(res=>{
      console.log(res);
      this.showSuccesfullMsg = true;
    }, err =>{
      this.errorMsg = true;
      console.log(err);
    })
  }

}
